const rgbToRyb = (color: Array<number>) => {
  let [r, g, b] = color;
  // Remove the whiteness from the color.
  const w = Math.min(r, g, b);
  r -= w;
  g -= w;
  b -= w;

  const mg = Math.max(r, g, b);

  // Get the yellow out of the red+green.
  let y = Math.min(r, g);
  r -= y;
  g -= y;

  // If this unfortunate conversion combines blue and green, then cut each in
  // half to preserve the value's maximum range.
  if (b && g) {
    b /= 2.0;
    g /= 2.0;
  }

  // Redistribute the remaining green.
  y += g;
  b += g;

  // Normalize to values.
  const my = Math.max(r, y, b);
  if (my) {
    const n = mg / my;
    r *= n;
    y *= n;
    b *= n;
  }

  // Add the white back in.
  r += w;
  y += w;
  b += w;

  // And return back the ryb typed accordingly.
  return [r, y, b];
};

export default rgbToRyb;
